import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ListView from "@/pages/ListView";
import AttendancePage from "@/pages/Attendance";
import SessionsPage from "@/pages/Sessions";
import AllocationPage from "@/pages/Allocation";
import AllocationsPage from "@/pages/Allocations";
import ReportPage from "@/pages/Report";
import ProfilePage from "@/pages/Profile";

import MastersHome from "@/pages/masters/MastersHome";
import LocationsPage from "@/pages/masters/Locations";
import DepartmentsPage from "@/pages/masters/Departments";
import JobRolesPage from "@/pages/masters/JobRoles";
import ShiftsPage from "@/pages/masters/Shifts";
import EmployeesPage from "@/pages/masters/Employees";
import UsersPage from "@/pages/masters/Users";
import { JOB_ROLE_ALLOWED_ROLES } from "@/lib/permissions";

const GlobalAdminOnly = ({ children }) => (
  <ProtectedRoute roles={["Administrator"]}>{children}</ProtectedRoute>
);
const MasterAllowed = ({ children }) => (
  <ProtectedRoute roles={["Administrator", "Location Admin"]}>{children}</ProtectedRoute>
);
const JobRoleOnly = ({ children }) => (
  <ProtectedRoute roles={JOB_ROLE_ALLOWED_ROLES}>{children}</ProtectedRoute>
);
const AttendantOnly = ({ children }) => (
  <ProtectedRoute roles={["Supervisor", "Assistant Supervisor", "Administrator", "Location Admin"]}>{children}</ProtectedRoute>
);
const SupervisorOrAdmin = ({ children }) => (
  <ProtectedRoute roles={["Supervisor", "Administrator", "Location Admin"]}>{children}</ProtectedRoute>
);
const AnyAuthed = ({ children }) => <ProtectedRoute>{children}</ProtectedRoute>;

function App() {
  return (
    <div className="App" data-testid="vision-app-root">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />

            <Route path="/dashboard" element={<AnyAuthed><Dashboard /></AnyAuthed>} />
            <Route path="/records"   element={<AnyAuthed><ListView /></AnyAuthed>} />
            <Route path="/profile"   element={<AnyAuthed><ProfilePage /></AnyAuthed>} />

            <Route path="/attendance" element={<AttendantOnly><AttendancePage /></AttendantOnly>} />
            <Route path="/attendance/session/:sid" element={<AttendantOnly><AttendancePage /></AttendantOnly>} />
            <Route path="/sessions" element={<AttendantOnly><SessionsPage /></AttendantOnly>} />
            <Route path="/allocation" element={<SupervisorOrAdmin><AllocationPage /></SupervisorOrAdmin>} />
            <Route path="/allocation/:sid" element={<SupervisorOrAdmin><AllocationPage /></SupervisorOrAdmin>} />
            <Route path="/allocations" element={<SupervisorOrAdmin><AllocationsPage /></SupervisorOrAdmin>} />
            <Route path="/report" element={<SupervisorOrAdmin><ReportPage /></SupervisorOrAdmin>} />

            <Route path="/masters"              element={<MasterAllowed><MastersHome /></MasterAllowed>} />
            <Route path="/masters/locations"    element={<GlobalAdminOnly><LocationsPage /></GlobalAdminOnly>} />
            <Route path="/masters/departments"  element={<MasterAllowed><DepartmentsPage /></MasterAllowed>} />
            <Route path="/masters/job-roles"    element={<JobRoleOnly><JobRolesPage /></JobRoleOnly>} />
            <Route path="/masters/job_roles"    element={<JobRoleOnly><JobRolesPage /></JobRoleOnly>} />
            <Route path="/masters/shifts"       element={<MasterAllowed><ShiftsPage /></MasterAllowed>} />
            <Route path="/masters/employees"    element={<MasterAllowed><EmployeesPage /></MasterAllowed>} />
            <Route path="/masters/users"        element={<GlobalAdminOnly><UsersPage /></GlobalAdminOnly>} />

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster richColors closeButton position="top-right" />
    </div>
  );
}

export default App;
